import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as firebase from 'firebase';
import { auth } from 'firebase/app';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { User } from '../models/User';
import { ModalContentComponent } from '../shared/modal-content/modal-content.component';
import { DataService } from './data.service';
import { OndernemingService } from './onderneming.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  errorMessageMapping = {
    'auth/invalid-email': 'De opgegeven e-mail is incorrect.',
    'auth/wrong-password': 'Het opgegeven wachtwoord is ongeldig.',
    'auth/account-exists-with-different-credential': 'Dit account bestaat al, maar met een ander wachtwoord.',
    'auth/email-already-exists': 'Dit e-mail adres is al in gebruik.',
    'auth/user-disabled': 'Dit account werd uitgeschakeld door de administrator.',
    'auth/invalid-user-token': 'Inloggegevevens zijn vervallen, gelieve opnieuw in te loggen',
    'auth/user-not-found': 'Deze gebruiker werd niet gevonden.',
    'auth/weak-password': 'Het gegeven wachtwoord is ongeldig. Een wachtwoord moet minimaal 6 karakters lang zijn.',
    'auth/too-many-requests':'Te veel foutieve aanmeldpogingen. Probeer het later nog eens opnieuw.'
  };
  isLoggedIn$ = this.afAuth.user.pipe(map(user => user !== null));

  constructor(public afs: AngularFirestore,
              public afAuth: AngularFireAuth,
              public router: Router,
              public ngZone: NgZone,
              private modalService: NgbModal,
              private firestore: AngularFirestore,
              public ondernemingService: OndernemingService,
              public dataService: DataService) {
  }

  // Sign in with email/password
  async signIn(email, password) {
    try {
      await this.afAuth.setPersistence(auth.Auth.Persistence.SESSION);
      const userCredential = await this.afAuth.signInWithEmailAndPassword(email, password);
      // Haal de user data op via het uid van de ingelogde gebruiker
      const user = await this.getUserData(userCredential.user.uid).toPromise();
      // this.SetUserData(result.user);
      // Zoek de bijhorende onderneming waarvan de gebruiker admin van is
      
      // const organization = await this.ondernemingService.getOndernemingNaam(user.adminVan).toPromise();
      // if (user.adminVan === 'admin') {
      //   this.dataService.adminVanOnderneming = 'admin';
      // } else {
      //   this.dataService.adminVanOnderneming = organization.naam;
      // }


      // navigeer naar de admin-pagina
      if (user.adminVan !== 'admin') {
        await this.ngZone.run(() => this.router.navigate(['/', user.adminVan, 'admin']));
      } else {
        await this.ngZone.run(() => this.router.navigate(['/privateAdmin']));
      }

    } catch (error) {
      this.handleLoginError(error);
    }
  }

  // Reset Forgot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        const modalRef = this.modalService.open(ModalContentComponent);

        modalRef.componentInstance.confirmationBoxTitle = 'Verzonden';
        modalRef.componentInstance.confirmationMessage = 'Er is een e-mail verzonden naar het opgegeven mail-adres. Controleer je inbox.';
        modalRef.componentInstance.bevestig = false;
        this.routeOnLogout();
      }).catch((error) => {
        this.handleLoginError(error);
      });
  }

  /**
   * Fetch user data from Users collection. Returns cached data if available.
   */
  getUserData(id: string): Observable<User | null> {
    if (this.dataService.user?.uid === id) {
      return of(this.dataService.user);
    }
    return this.firestore.collection('Users', ref => ref.where('uid', '==', id)).get().pipe(take(1),
      map(queryResult => {
        if (!queryResult.empty) {
          const user = queryResult.docs[ 0 ];
          this.dataService.user = user.data() as User;
        } else {
          this.dataService.user = null;
        }
        return this.dataService.user;
      }));
  }

  getUser(): Observable<firebase.User> {
    return this.afAuth.user;
  }
  async addUser(email: string, password:string)
  {
    return await this.afAuth.createUserWithEmailAndPassword(email, password);
  }

  /* Setting up user data when sign in with username/password,
  sign up with username/password and sign in with social auth
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  async SetUserData(user: User) {

   await this.afs.doc(`Users/${user.uid}`).set(user);
    
  }



  /**
   * Navigation route on logout
   * Small delay on logout for user experience
   */
  async routeOnLogout() {
    const pathNaam = JSON.parse(localStorage.getItem('onderneming'));
    //const pathId = JSON.parse(localStorage.getItem('ondernemingId'));
    this.router.navigate(['logout']);
    setTimeout(() => {
      if (pathNaam == null) {
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['/', pathNaam, 'tools']);
      }

    }, 2500);
  }

  // Sign out
  SignOut() {
    return this.afAuth.signOut().then(() => {
      this.routeOnLogout();
    });
  }

  private handleLoginError(error: auth.Error) {
    const message = this.errorMessageMapping[ error.code ] ?? error.message;
    const modalRef = this.modalService.open(ModalContentComponent);

    modalRef.componentInstance.confirmationBoxTitle = 'Error';
    modalRef.componentInstance.confirmationMessage = message;
    modalRef.componentInstance.bevestig = false;
  }


}
